<template>
  <div class="mapping-search-result-item-root">
    <div class="mapping-search-result-item-label">
      {{ item.label }}
    </div>
    <div
      class="mapping-search-result-item-actions"
    >
      <Button
        class="map-result-btn"
        variant="primary"
        @click="mapResult"
      >
        Map this result
      </Button>
      <Button
        v-if="showViewHistory"
        class="map-result-btn"
        variant="secondary"
        :disabled="viewHistoryDisabled"
        @click="viewHistory"
      >
        View history
      </Button>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import Button from '@/components/common/Button';

export default {
  emits: ['onMapResult', 'viewHistory'],
  props: {
    item: {
      type: Object,
      required: true,
    },
    mappingType: {
      required: true,
      type: String,
    },
  },
  components: {
    Button,
  },
  setup(props, { emit }) {
    const mapResult = () => {
      emit('onMapResult', props.item);
    };
    const showViewHistory = computed(() => props.mappingType === 'COMPETITORS_MAPPING');
    const viewHistoryDisabled = computed(() => !props.item?.previousOpponents?.length);

    const viewHistory = () => {
      emit('viewHistory', {
        mapping: {
          extRef: props.item.label,
          previousOpponents: props.item.previousOpponents,
        },
      });
    };

    return {
      viewHistoryDisabled,
      showViewHistory,
      mapResult,
      viewHistory,
    };
  },
};
</script>

<style lang="scss">
.mapping-search-result-item-root {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 21px 12px;
  min-height: 75px;
  cursor: pointer;

  &:hover {
    background-color: $gray300;
    .mapping-search-result-item-actions {
      display: flex;
    }
  }

  .mapping-search-result-item-actions {
    display: none;
    align-items: center;
    gap: 8px;
  }
}
</style>
